import { AUTH_CALLBACK_PATH } from "./authRoutes";
import { createSsoAuthorizationRequest } from "./pkce";

interface BuildSsoAuthorizeUrlArgs {
  domain: string;
  clientId: string;
  identityProvider: string;
  loginHint: string;
  state: string;
  codeChallenge: string;
  redirectUri: string;
}

export const buildSsoAuthorizeUrl = ({
  domain,
  clientId,
  identityProvider,
  loginHint,
  state,
  codeChallenge,
  redirectUri,
}: BuildSsoAuthorizeUrlArgs): string => {
  const scope = "openid email profile";
  const params = new URLSearchParams({
    identity_provider: identityProvider,
    login_hint: loginHint,
    redirect_uri: redirectUri,
    response_type: "code",
    client_id: clientId,
    scope,
    state,
    code_challenge: codeChallenge,
    code_challenge_method: "S256",
  });

  return `${domain}/oauth2/authorize?${params.toString()}`;
};

interface StartSsoLoginArgs {
  domain: string;
  clientId: string;
  identityProvider: string;
  loginHint: string;
}

export const startSsoLogin = async ({
  domain,
  clientId,
  identityProvider,
  loginHint,
}: StartSsoLoginArgs): Promise<void> => {
  const { state, codeChallenge } = await createSsoAuthorizationRequest({
    domain,
    clientId,
  });

  window.location.assign(
    buildSsoAuthorizeUrl({
      domain,
      clientId,
      identityProvider,
      loginHint,
      state,
      codeChallenge,
      redirectUri: `${window.location.origin}${AUTH_CALLBACK_PATH}`,
    }),
  );
};
